const MAPS_URL = "https://www.google.com/maps/dir/?api=1&destination=125+Wattegedara+Rd,+Maharagama+10280,+Sri+Lanka";
const MAPS_EMBED = "https://maps.google.com/maps?q=125+Wattegedara+Rd,+Maharagama+10280,+Sri+Lanka&z=15&output=embed";

export default function SiteFooter() {
  return (
    <footer style={{ padding: "80px 0 36px", borderTop: "1px solid var(--ink)", background: "#fff", position: "relative" }}>
      <div style={{ maxWidth: "1440px", margin: "0 auto", padding: "0 32px" }}>

        {/* Top CTA row */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr auto", alignItems: "end", gap: "40px" }}>
          <div style={{ display: "flex", alignItems: "stretch", gap: "32px" }}>
            <div style={{ width: "4px", background: "var(--blue)", flexShrink: 0 }} />
            <h3 style={{ fontSize: "clamp(40px, 5.2vw, 76px)", lineHeight: 0.98, letterSpacing: "-0.025em", fontWeight: 500 }}>
              Framing Your <span style={{ fontWeight: 400, color: "var(--blue)" }}>Vision</span><br />
              with Precision.
            </h3>
          </div>
          <a
            href="#contact"
            style={{ display: "inline-flex", alignItems: "center", gap: "12px", padding: "18px 24px", border: "1px solid var(--blue)", background: "var(--blue)", color: "#fff", fontFamily: "'JetBrains Mono', monospace", fontSize: "12px", letterSpacing: "0.12em", textTransform: "uppercase", transition: "all .2s", textDecoration: "none" }}
            onMouseEnter={e => { e.currentTarget.style.background = "#0000cc"; e.currentTarget.style.borderColor = "#0000cc"; }}
            onMouseLeave={e => { e.currentTarget.style.background = "var(--blue)"; e.currentTarget.style.borderColor = "var(--blue)"; }}
          >
            Start a project <span>→</span>
          </a>
        </div>

        {/* Horizontal rule */}
        <div style={{ height: "1px", background: "var(--ink)", margin: "56px 0 40px" }} />

        {/* 4-col grid */}
        <div className="footer-grid" style={{ display: "grid", gridTemplateColumns: "1.6fr 1fr 1fr 1fr", gap: "48px" }}>

          {/* Brand */}
          <div>
            <a href="#" style={{ display: "flex", alignItems: "center", gap: "12px", textDecoration: "none", color: "inherit" }}>
              <div className="logo-mark" style={{ width: "44px", height: "44px" }}>
                <img src={`${process.env.PUBLIC_URL}/logo-he-enterprises.png`} alt="HE Enterprises logo" />
              </div>
              <div style={{ fontWeight: 600, letterSpacing: "-0.01em", fontSize: "16px", lineHeight: 1.2 }}>
                Hatharasinghe Enterprises
                <small style={{ display: "block", fontFamily: "'JetBrains Mono', monospace", fontSize: "9px", letterSpacing: "0.14em", textTransform: "uppercase", color: "var(--muted)", fontWeight: 400, marginTop: "2px" }}>
                  Est. 2004
                </small>
              </div>
            </a>
            <p style={{ marginTop: "16px", fontSize: "14px", lineHeight: 1.55, color: "#333", maxWidth: "36ch" }}>
              Aluminium construction, cladding, partitions and glasswork for government and private projects across Sri Lanka.
            </p>
          </div>

          {/* Navigate */}
          <div>
            <h5 style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: "10px", letterSpacing: "0.14em", textTransform: "uppercase", color: "var(--muted)", marginBottom: "16px" }}>Navigate</h5>
            <ul style={{ listStyle: "none", display: "flex", flexDirection: "column", gap: "10px" }}>
              {[["#work", "Selected work"], ["#about", "About"], ["#services", "Services"], ["#contact", "Contact"]].map(([href, label]) => (
                <li key={label}><a href={href} className="fv-link" style={{ fontSize: "14px" }}>{label}</a></li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h5 style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: "10px", letterSpacing: "0.14em", textTransform: "uppercase", color: "var(--muted)", marginBottom: "16px" }}>Services</h5>
            <ul style={{ listStyle: "none", display: "flex", flexDirection: "column", gap: "10px" }}>
              {["Aluminium Fabrication", "Cladding & Ceilings", "Partitions & Iron Work", "Glass Work", "Pantry Cupboards", "Roller Doors"].map(s => (
                <li key={s} style={{ fontSize: "14px" }}>{s}</li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h5 style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: "10px", letterSpacing: "0.14em", textTransform: "uppercase", color: "var(--muted)", marginBottom: "16px" }}>Get in touch</h5>
            <ul style={{ listStyle: "none", display: "flex", flexDirection: "column", gap: "10px" }}>
              <li style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
                <a href="tel:+94777754050" className="fv-link" style={{ fontSize: "14px" }}>+94 77 775 4050</a>
                <span style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: "9px", letterSpacing: "0.1em", textTransform: "uppercase", padding: "2px 6px", border: "1px solid var(--line)", color: "var(--muted)" }}>Founder</span>
              </li>
              <li style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
                <a href="tel:+94771648604" className="fv-link" style={{ fontSize: "14px" }}>+94 77 164 8604</a>
                <span style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: "9px", letterSpacing: "0.1em", textTransform: "uppercase", padding: "2px 6px", border: "1px solid var(--line)", color: "var(--muted)" }}>PM</span>
              </li>
              <li style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: "11px", letterSpacing: "0.08em", color: "var(--muted)" }}>08:00 — 19:00 · Mon — Sat</li>
            </ul>
          </div>
        </div>

        {/* Map card */}
        <a
          className="fv-map"
          href={MAPS_URL}
          target="_blank"
          rel="noopener noreferrer"
          style={{ marginTop: "40px" }}
        >
          <div style={{ position: "relative", minHeight: "220px", background: "#e8e8e8", overflow: "hidden" }}>
            <iframe
              src={MAPS_EMBED}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              tabIndex="-1"
              aria-hidden="true"
              title="Workshop location"
              style={{ position: "absolute", inset: 0, width: "100%", height: "100%", border: 0, filter: "grayscale(1) contrast(0.95)", pointerEvents: "none" }}
            />
          </div>
          <div style={{ padding: "24px", display: "flex", flexDirection: "column", justifyContent: "space-between", gap: "12px", background: "#fff" }}>
            <div style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: "10px", letterSpacing: "0.14em", textTransform: "uppercase", color: "var(--blue)" }}>// Visit the workshop</div>
            <div style={{ fontSize: "18px", fontWeight: 500, lineHeight: 1.3 }}>125 Wattegedara Road<br />Maharagama 10280, Sri Lanka</div>
            <div style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: "11px", letterSpacing: "0.1em", textTransform: "uppercase", borderTop: "1px solid var(--line)", paddingTop: "12px", display: "flex", justifyContent: "space-between" }}>
              Open directions in Google Maps <span>↗</span>
            </div>
          </div>
        </a>

        {/* Bottom bar */}
        <div style={{ display: "flex", justifyContent: "space-between", paddingTop: "24px", marginTop: "40px", borderTop: "1px solid var(--line)", fontFamily: "'JetBrains Mono', monospace", fontSize: "10px", letterSpacing: "0.1em", color: "var(--muted)", textTransform: "uppercase", flexWrap: "wrap", gap: "8px" }}>
          <span>© 2004 — 2026 Hatharasinghe Enterprises (Pvt) Ltd</span>
          <span>Maharagama · LK · N 06°50' · E 79°55'</span>
        </div>
      </div>
    </footer>
  );
}
